import marketingImage1 from "../../images/MarkeingCard/marketingImage1.png";
import marketingImage2 from "../../images/MarkeingCard/marketingImage2.png";
import marketingImage3 from "../../images/MarkeingCard/marketingImage3.png";

export const MarketingData = [
  {
    image: marketingImage1,
    publishBy: "Youtube • 4 months ago",
    publishTitle: "Boost Customer Engagement",
    publishDescription:
      "Struggling with customer engagement and sales inquiries? Learn about Skalebot",
    badges: ["Skalebot Pro", "Management", "Ulitimate Business"],
    url: "https://youtu.be/pQ92QtgEOeU?si=rn7AGAQKTJlXQWP9"
  },
  {
    image: marketingImage2,
    publishBy: "Linkedin • 2 days ago",
    publishTitle: "Drives For Sales Growth",
    publishDescription:
      "Skalebot helps Goldprince Jewellery to tackle customer support challenges and boost Sales",
    badges: ["Skalebot Pro", "Support Challenge", "Boost Sales"],
    url: "https://www.linkedin.com/feed/update/urn:li:activity:7089549506509213696"
  },
  {
    image: marketingImage3,
    publishBy: "Linkedin • 2 days ago",
    publishTitle: "Strategies and Approaches",
    publishDescription:
      "The difference between Traditional marketing and WhatsApp Marketing",
    badges: ["Skalebot Pro", "Whatsapp Marketing", "Stratagie"],
    url: "https://www.linkedin.com/feed/update/urn:li:activity:6997791913969926144"
  }
];
